import type { FC } from 'react'
import { MenuItem, TextField } from '@mui/material'
import { useMembersContracts } from './MembersDashboardService'

interface Props {
  value: number | null
  onChange: (contractId: number | null) => void
}

// Single-select contract scope; "All contracts" (empty) clears it. Options are the
// contracts with attributed members in this tenant (from the members BFF).
const ContractFilter: FC<Props> = ({ value, onChange }) => {
  const { data } = useMembersContracts()
  const contracts = data?.contracts ?? []
  return (
    <TextField
      select
      size="small"
      label="Contract"
      value={value ?? ''}
      onChange={e => onChange(e.target.value === '' ? null : Number(e.target.value))}
      sx={{ minWidth: 200 }}
      data-qa="contract-filter"
    >
      <MenuItem value="">All contracts</MenuItem>
      {contracts.map(contract => (
        <MenuItem key={contract.id} value={contract.id}>
          {contract.name ?? `Contract ${contract.id}`}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default ContractFilter
